// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3D6bI","title":"Images90_title__2wT-4","images":"Images90_images__lF2wQ"};